"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportIpReportSchema = exports.runIpReportSchema = exports.ipReportExportFormatEnum = void 0;
const zod_1 = require("zod");
/** IP reporting contracts — ADR-085 Phase 11. */
exports.ipReportExportFormatEnum = zod_1.z.enum(['CSV', 'EXCEL', 'PDF']);
/**
 * Filters are an OPEN map, validated per report against its declared filter
 * specs. A fixed schema here would mean editing this file every time any report
 * gains a filter — exactly the duplication the framework exists to remove.
 */
exports.runIpReportSchema = zod_1.z.object({
    filters: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    page: zod_1.z.coerce.number().int().positive().default(1),
    /** Capped so one request cannot pull a 500,000-row register into memory. */
    pageSize: zod_1.z.coerce.number().int().positive().max(200).default(50),
    sortBy: zod_1.z.string().max(60).optional(),
    sortDir: zod_1.z.enum(['asc', 'desc']).optional(),
    /** Opt-in: the integrity verdict runs several hashes per row. */
    includeIntegrity: zod_1.z.coerce.boolean().optional(),
});
exports.exportIpReportSchema = exports.runIpReportSchema.extend({
    format: exports.ipReportExportFormatEnum,
});
//# sourceMappingURL=ip-report.schema.js.map